import { ActivityBlockType } from './Activity';
import { Model, Nullable, Ordenable } from './Model';

export enum AssessmentItemTypeEnum {
  MANUAL = 'MANUAL',
  DIGITAL_ACTIVITY = 'DIGITAL_ACTIVITY',
  TEST = 'TEST',
}

export const TYPES_WITH_CRITERIA = [
  AssessmentItemTypeEnum.MANUAL,
  AssessmentItemTypeEnum.DIGITAL_ACTIVITY,
];

export interface AssessmentCriteria extends Model, Ordenable {
  assessmentItemId: number;
  name: string;
  description?: Nullable<string>;
  maxGrade: number;
  activityType?: Nullable<ActivityBlockType>;
}

export interface AssessmentItem extends Model, Ordenable {
  assessmentId: number;
  name: string;
  description?: string;
  maxGrade: number;
  type: AssessmentItemTypeEnum;
  criteria?: AssessmentCriteria[];
}

export interface Assessment extends Model, Ordenable {
  evaluationId: number;
  name: string;
  description?: string;
  maxGrade: number;
  lessonBlockIds: number[];
  items: AssessmentItem[];
}
